const getters = {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    roles: state => state.user.roles,
    permissions: state => state.user.permissions,
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    language: state => state.app.language
}
export default getters